import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-quickbooks-connected',
  templateUrl: './quickbooks-connected.component.html',
  styleUrls: ['./quickbooks-connected.component.css']
})
export class QuickbooksConnectedComponent implements OnInit {
  isSuccess = true;
  companyName = '';
  message = '';

  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router
  ) { }

  ngOnInit(): void {
    const query = this.activatedRoute.snapshot.queryParamMap;
    this.isSuccess = (query.get('status') || 'success') !== 'error';
    this.companyName = query.get('company') || '';
    this.message = query.get('message') || '';
    this.notifyOpener();
  }

  onContinue() {
    if (window.opener && !window.opener.closed) {
      window.opener.focus();
      window.close();
      return;
    }
    this.router.navigateByUrl('/companies');
  }

  private notifyOpener() {
    if (!window.opener || window.opener.closed) {
      return;
    }
    window.opener.postMessage({
      type: 'QB_COMPANY_CONNECTED',
      status: this.isSuccess ? 'success' : 'error'
    }, window.location.origin);
  }
}
